import React from 'react';
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { withTranslation } from 'react-i18next';
import i18n from "../../i18n";
import * as rk from '../../localization/resourceKeys';
import { ErrorIcon } from '../Icons/icons';
import PropTypes from "prop-types";

const RetryScreen = (props) => {
    const history = useHistory();

    const tryAgain = () => {
        if (props.requestForm.step?.selectedFlow === "check") {
            history.push('/verificationForm');
        } else {
            history.push('/mailingAddress');
        }
    }

    return <>
        <div className="u-m-none">
            <div className="u-1/1 u-text-center">
                <ErrorIcon />
            </div>
        </div>
        <div className="u-m-none u-mb">
            <div className="u-1/1 u-text-center request-confirmation-text">
                {props.error}
            </div>
        </div>
        <div className="u-m-none">
            <div className="u-1/1 center-div portal-home-button">
                <button
                    className="c-btn"
                    disabled={false}
                    onClick={tryAgain}
                    data-testid="retryButton"
                >
                    <span className="c-btn__text">
                        {i18n.t(rk.BUTTON.TRY_AGAIN)}
                    </span>
                </button>
            </div>
        </div>
    </>;
};

RetryScreen.propTypes = {
    error: PropTypes.string,
    requestForm: {
        step: PropTypes.shape({
            selectedFlow: PropTypes.string,
        }),
    },
};

const mapStateToProps = (state) => ({
    stateSelector: state.stateSelector,
    requestForm: state.requestForm,
});

export default connect(mapStateToProps)(withTranslation()(RetryScreen));